export enum CookVerificationStatus{
    REPORT_GENERATED = "REPORT_GENERATED",
    NOT_REQUESTED="NOT_REQUESTED", 
    INSUFFICIENT_DET="INSUFFICIENT_DET", 
    INITIATED= "INITIATED"
}